import Accordion from "@/common/components/Accordion"
import Checkbox from "@/common/components/Checkbox"
import SelectController from "@/common/components/SelectController"
import useDebounce from "@/common/hooks/useDebounce"
import { Mapper } from "@/common/services/mapper"
import { useEstablishmentCompanies } from "@/features/establishments/hooks/useEstablishmentCompanies"
import { EstablishmentCompanyTransformer } from "@/features/establishments/services/establishmentCompanyTransformer"
import { establishmentBlockModeOptions } from "@/features/privateCompanies/constants/establishmentBlockModeOptions.constant"
import { CompanyBranchValidationSchema } from "@/features/privateCompanies/schemas/createBranch.schema"
import { Control, FieldErrors, UseFormRegister, UseFormWatch } from "react-hook-form"

export const EstablishmentRestriction = (
  {
    control,
    register,
    watch,
    errors,
    disabled,
  }: {
    control: Control<CompanyBranchValidationSchema, any>
    register: UseFormRegister<CompanyBranchValidationSchema>
    watch: UseFormWatch<CompanyBranchValidationSchema>
    errors: FieldErrors<CompanyBranchValidationSchema>
    disabled?: boolean
  }
) => {
  const [searchEstablishmentCompanies, setSearchEstablishmentCompanies] = useDebounce('')

  const { data: establishmentCompaniesOptions } = useEstablishmentCompanies({
    filters: { search: searchEstablishmentCompanies },
    mapper: Mapper.mapWithTransformer({
      transformer: EstablishmentCompanyTransformer.optionTransformer()
    })
  })

  const enableEstablishmentRestriction = watch('enableEstablishmentRestriction')

  return (
    <Accordion
      head={(
        <Checkbox
          label="Restrição de Estabelecimentos"
          errorMessage={errors.enableEstablishmentRestriction?.message}
          {...register('enableEstablishmentRestriction')}
          disabled={disabled}
        />
      )}
      body={(
        <div className="flex flex-col gap-4">
          <SelectController
            control={control}
            name="establishment_block_mode"
            label="Tipo de restrição"
            markAsRequired
            errorMessage={errors.establishment_block_mode?.message}
            options={establishmentBlockModeOptions}
            isDisabled={!enableEstablishmentRestriction || disabled}
          />
          <SelectController
            control={control}
            name="allowed_or_blocked_establishments_attributes"
            label="Estabelecimentos"
            errorMessage={errors.allowed_or_blocked_establishments_attributes?.message}
            options={establishmentCompaniesOptions}
            onInputChange={(value) => setSearchEstablishmentCompanies(value)}
            isMulti
            isDisabled={!enableEstablishmentRestriction || disabled}
          />
        </div>
      )}
    />
  )
}
